import { render, staticRenderFns } from "./EmployerNavbarContainer3.vue?vue&type=template&id=4a8e7aca"
import script from "./EmployerNavbarContainer3.vue?vue&type=script&lang=js"
export * from "./EmployerNavbarContainer3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports